import type { QuizAttemptPublic } from '@repo/types/quiz';

export function getBestQuizResponse(quizresps?: QuizAttemptPublic[]): QuizAttemptPublic | undefined {
  return quizresps?.reduce<QuizAttemptPublic | undefined>((best, curr) => (curr.score != null && (best == null || curr.score > (best.score ?? -Infinity)) ? curr : best), undefined);
}
